import { updateDataAction } from '../actions/form';
import { createReducer } from 'redux-create-reducer';

const dirtyReducer = createReducer(false, {
  [updateDataAction]: (state, action) => true,
});

export default dirtyReducer;

export const getIsDirty = state => state.dirty;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step3/reducers/dirty.js